// extracted by mini-css-extract-plugin
module.exports = {"cart":"Cart_cart__RkyAa","icon":"Cart_icon__1IqLa","text":"Cart_text__8Bg7F"};